import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Http from "../Common/Http";
import IsLogin from "../Common/IsLogin";
import AdminDashboard from "./Dashboard/Admin";
import SupplyChainAndProduction from "./Dashboard/SupplychainAndProduction";
import StaffDashboard from "./Dashboard/Staff";
import AccountsDashboard from "./Dashboard/AccountsDashboard";
import KitchenDashboard from "./Dashboard/kitchen";
import GM from "./Dashboard/GM";
// import $ from "jquery";

const Dashboard = () => {
  const [receiveData, setReceiveData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    const fetchData = async () => {
      try {
        const res = await Http.get("/staff-type-check");
        setReceiveData(res.data);
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);



  return (
    <div>
      <IsLogin></IsLogin>
      {/* <LoaderComponent /> */}
      {loading ? (
        <ProgressSpinner className="dashLoad" />
      ) : (
        <>
          {(receiveData === "admin" ||
            receiveData === "depot" || receiveData === "admin_viewer") && <AdminDashboard />}
          {(receiveData === "supply_chain" || receiveData === 'production') && <SupplyChainAndProduction />}
          {(receiveData === "accounts") && <AccountsDashboard />}
          {(receiveData === "staff" ||
            receiveData === "hr" ||
            receiveData === "so") && <StaffDashboard />}

          {(receiveData === "kitchen" || receiveData === "kitchen_manager") && (
            <KitchenDashboard />
          )}

          {receiveData === "gm" && (<GM />)}

        </>
      )}
    </div>
  );
};

export default Dashboard;
